/** 当element第一次可见后 触发onVisible */
export const obLazyRender = (element, onVisible, options) => {
  const ob = new IntersectionObserver((entries, observer) => {
    var _entries$;
    const visible = (_entries$ = entries[0]) === null || _entries$ === void 0 ? void 0 : _entries$.isIntersecting;
    if (visible) {
      onVisible();
      observer.disconnect();
    }
  }, options);
  ob.observe(element);
  return () => {
    ob.disconnect();
  };
};
//# sourceMappingURL=obInterSection.js.map
